/**
 * Social login account register dialog Component
 */
/* jshint ignore:start */
(function (itxApp) {

    'use strict';

    /**
     * Social login account register
     */
    var ItxSocialLoginRegisterAccountDialogCmp = {
        bindings: {
            closeDialog: '&',
            onContinue: '&',
            user: '='
        },
        controller: ItxSocialLoginRegisterAccountDialogCmpCtrl,
        controllerAs: 'socialLoginRegisterAccountDialogCtrl',
        templateUrl: ['$element', '$attrs', function ($element, $attrs) {
            return $attrs.template || 'social-login-register-account-dialog.tpl';
        }]
    };

    ItxSocialLoginRegisterAccountDialogCmpCtrl.$inject = ['$rootScope', '$scope', 'ngDialog', 'ItxErrorMessagesFct'];

    function ItxSocialLoginRegisterAccountDialogCmpCtrl($rootScope, $scope, ngDialog, ItxErrorMessagesFct) {
        var _this = this;
        _this.optionsModel = null;
        _this.readonly = _this.user.email ? true : false;
         
        _this.userModel = {
            socialId: _this.user.socialId,
            socialToken: _this.user.socialToken,
            email: _this.user.email,
            privacyPolicyAccepted: false,
            socialType:_this.user.socialType,
            primaryAddress: {
                "firstName": _this.user.name,
                "lastName": "",
                "isCompany": false,
                "birthdate": "",
                "addressLines": [""],
                "city": "",
                "stateCode": "",
                "countryCode": inditex.iStoreJSON.countryCode,
                "countryName": inditex.iStoreJSON.countryName,
                "zipCode": "",
                "phones": [{
                    "countryCode": "",
                    "subscriberNumber": ""
                }]
            }
        };

        _this.next = function () {
            _this.loginForm.$setSubmitted();
            if (_this.loginForm.$valid) {
                _this.userModel.privacyPolicyAccepted = true;
                if (!_this.user.email) _this.user.email = _this.userModel.email;
                if (_this.optionsModel.newsletterAccepted) {
                    _this.userModel.newsletter = 'newsletterGeneral';
                }
                _this.onContinue({ user: _this.userModel });
            }
        }

    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxSocialLoginRegisterAccountDialog', ItxSocialLoginRegisterAccountDialogCmp);

    itxApp.common.ItxSocialLoginRegisterAccountDialogCmp = ItxSocialLoginRegisterAccountDialogCmp;
    itxApp.common.ItxSocialLoginRegisterAccountDialogCmpCtrl = ItxSocialLoginRegisterAccountDialogCmpCtrl;

})(window.itxApp);
/* jshint ignore:end */